import { useContext } from "react";

import { OrgContext } from "@providers/OrgProvider";

export const useOrg = () => {
  const { org } = useContext(OrgContext);
  return org;
};
